import * as toolbox from 'components/common/toolbox';
import ActivityLog from 'components/activity-log/activity-log';
import Authorize from 'components/common/authorize';
import Badge from 'components/common/Badge';
import CatchErrors from 'components/common/catch-errors';
import ExpiringDocsTab from 'components/attachments/expiring-docs-tab';
import InvoicesTab from 'components/invoices/invoices-tab';
import QuotesTab from 'components/quotes/quotes-tab';
import React from 'react';
import ServiceRequestsTab from 'components/service-requests/service-requests-tab';
import StockPartsTab from 'components/inventory/stock-parts-tab';
import { APPS, LOG, PERMISSIONS } from 'components/constants';
import { useParams, useRouteMatch, Route, Link } from "react-router-dom";
import { useSelector } from 'react-redux';

export default function AssetTabs(props) {
	
	const seg = 7;
	const match = useRouteMatch();
    const params = useParams();

	const asset = useSelector((store) => store.assets.asset);
	const assetTypes = useSelector((store) => store.settings.settings_asset_types);
	const settings = useSelector((store) => store.settings.settings);
	const user = useSelector(store => store.users?.user);
	const userPermissions = useSelector((store) => store.users.user_permissions);

	const assetType = assetTypes?.find((assetType) => assetType.id == asset?.assetTypeId);
	const isCustomerAssigned = (asset?.customerId === user?.profileId);

	const defaultAttach = [
		...(assetType?.option_vehicle_title) ? [{ name: 'Title' }] : [], 
		...(assetType?.option_registration) ? [{ name: 'Registration' }] : [], 
		...(assetType?.option_insurance) ? [{ name: 'Insurance' }] : [], 
		...(assetType?.option_bill_of_sale) ? [{ name: 'Bill of Sale' }] : [], 
	];

	function tab_active(value) {
		return (params.tab === value) ? ' active' : ''; // returns 'active' if value tab is active
	}
	function tab_url(value) {
		return toolbox.modifyPath(props.location.pathname, seg, value, seg);
	}
	
	return (
		<>
			<Route path={match.path} render={(route_props) =>

				<div className="tabs-container mt-3">
					<ul className="nav nav-tabs underline" role="tablist">
						
						<Authorize appId={ APPS.ASSETS.id } permKeys={ [PERMISSIONS.SERVICE_REQUESTS_VIEW.key, PERMISSIONS.SERVICE_REQUESTS_ASSIGNED_VIEW.key] }>
							<li className="position-relative">
								<Badge type={'info'} number={asset?.openServiceRequestCount} />
								<Link className={'nav-link' + tab_active('service_requests')} to={tab_url('service_requests')} replace={true}>
									<i title="Open Service Requests" className="fa-duotone fa-solid fa-folder-grid fa-2x m-0"></i>
									<br />SR
								</Link>
							</li>
						</Authorize>
						<Authorize appId={ APPS.ASSETS.id } permKeys={ [PERMISSIONS.SERVICE_REQUESTS_VIEW.key, PERMISSIONS.SERVICE_REQUESTS_ASSIGNED_VIEW.key] }>
							<li className="position-relative">
								<Badge type={'info'} number={asset?.serviceHistoryCount} />
								<Link className={'nav-link' + tab_active('service_history')} to={tab_url('service_history')} replace={true}>
									<i title="Service History" className="fa-duotone fa-solid fa-folder-check fa-2x m-0"></i>
									<br />HST
								</Link>
							</li>
						</Authorize>
						<Authorize feature={'generate_quotes'} appId={ APPS.ASSETS.id } permKeys={ [PERMISSIONS.QUOTES_VIEW.key] }>
							<li className="position-relative">
								<Badge type={'info'} number={asset?.quoteCount} />
								<Link className={'nav-link' + tab_active('quotes')} to={tab_url('quotes')} replace={true}>
									<i title="Quotes" className="fa-duotone fa-solid fa-message-quote fa-2x m-0"></i>
									<br />QT
								</Link>
							</li>
						</Authorize>
						<Authorize appId={ APPS.ASSETS.id } perm={ PERMISSIONS.ASSETS_LIC_DOCS }>
							<li className="position-relative">
								<Badge type={'info'} number={asset?.expiringDocs} />
								<Link className={'nav-link' + tab_active('attachments')} to={tab_url('attachments')} replace={true}>
									<i title="Licenses / Documents" className="fa-duotone fa-solid fa-file-certificate fa-2x m-0"></i>
									<br />DOC								</Link>
							</li>
						</Authorize>
						<Authorize appId={ APPS.ASSETS.id } perm={ PERMISSIONS.ASSETS_VIEW }>
							<li className="position-relative">
								<Badge type={'info'} number={asset?.stockPartIds?.length || 0} />
								<Link className={'nav-link' + tab_active('inventory')} to={tab_url('inventory')} replace={true}>
									<i title="Linked Stock Parts" className="fa-duotone fa-solid fa-screwdriver-wrench fa-2x m-0"></i>
									<br />PRT
								</Link>
							</li>
						</Authorize>
						<Authorize feature={'generate_invoices'} appId={ APPS.ASSETS.id } perm={ PERMISSIONS.INVOICES_VIEW }>
							<li className="position-relative">
								<Badge type={'info'} number={asset?.invoiceCount} />
								<Link className={'nav-link' + tab_active('invoices')} to={tab_url('invoices')} replace={true}>
									<i title="Invoices" className="fa-duotone fa-solid fa-file-lines fa-2x m-0"></i>
									<br />INV
								</Link>
							</li>
						</Authorize>
					</ul>

					<div className="tab-content">

						<Authorize appId={ APPS.ASSETS.id } permKeys={ [PERMISSIONS.SERVICE_REQUESTS_VIEW.key, PERMISSIONS.SERVICE_REQUESTS_ASSIGNED_VIEW.key] }>
							<div role="tabpanel" className={'tab-pane' + tab_active('service_requests')}>
								<div className="panel-body">
									<Route path={match.path} render={(route_props) =>
										<CatchErrors >
											<ServiceRequestsTab {...route_props} source="service_requests" />
										</CatchErrors>
									} />
								</div>
							</div>
						</Authorize>
						<Authorize appId={ APPS.ASSETS.id } permKeys={ [PERMISSIONS.SERVICE_REQUESTS_VIEW.key, PERMISSIONS.SERVICE_REQUESTS_ASSIGNED_VIEW.key] }>
							<div role="tabpanel" className={'tab-pane' + tab_active('service_history')}>
								<div className="panel-body">
									<Route path={match.path} render={(route_props) =>
										<CatchErrors >
											<ServiceRequestsTab {...route_props} source="service_history" />
										</CatchErrors>
									} />
								</div>
							</div>
						</Authorize>
						<Authorize feature={'generate_quotes'} appId={ APPS.ASSETS.id } perm={ PERMISSIONS.QUOTES_VIEW }>
							<div role="tabpanel" className={'tab-pane' + tab_active('quotes')}>
								<div className="panel-body">
									<Route path={props.match.path} render={(route_props) =>
										<CatchErrors>
											<h2>Coming...</h2>
											{/* <QuotesTab {...route_props} source="assets" /> */}
										</CatchErrors>
									} />
								</div>
							</div>
						</Authorize>
						<Authorize appId={ APPS.ASSETS.id } perm={ PERMISSIONS.ASSETS_LIC_DOCS }>
							<div role="tabpanel" className={'tab-pane' + tab_active('attachments')}>
								<div className="panel-body">
									<Route path={match.path} render={(route_props) =>
										<CatchErrors >
											<ExpiringDocsTab {...route_props} 
												id={ params.asset_id } 
												button="+ Document"
												field="expiring_docs"
												name="Licenses / Docs"
												prefix="ASSET" 
												singular="asset" 
												store="assets" 
												source="assets" 
												expires={ true }
												defaultAttach={ defaultAttach }
												setFocused={ props.setFocused }
												title="Licenses / Docs"
											/>
										</CatchErrors>
									} />
								</div>
							</div>
						</Authorize>
						<Authorize appId={ APPS.ASSETS.id } perm={ PERMISSIONS.ASSETS_VIEW }>
							<div role="tabpanel" className={'tab-pane' + tab_active('inventory')}>
								<div className="panel-body">
									<Route path={match.path} render={(route_props) =>
										<CatchErrors >
											<StockPartsTab {...route_props} source="assets" />
										</CatchErrors>
									} />
								</div>
							</div>
						</Authorize>
						<div role="tabpanel" className={'tab-pane' + tab_active('invoices')}>
							<div className="panel-body">
								<Route path={match.path} render={(route_props) =>
									<CatchErrors >
										<InvoicesTab {...route_props}
											prefix="ASSET" 
											singular='asset' 
											source='assets' 
                                            store="assets" 
										/>
									</CatchErrors>
								} />
							</div>
						</div>
					</div>
				</div>

			} />
		</>
	);
};

